import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-slate-50">
      <div className="bg-white p-8 rounded-xl shadow text-center max-w-md">
        <h2 className="text-4xl font-bold text-red-600 mb-4">404</h2>
        <p className="text-lg text-gray-700 mb-6">Página não encontrada.</p>
        <button
          onClick={() => navigate('/')}
          className="px-6 py-3 bg-indigo-600 text-white rounded-lg font-semibold shadow hover:bg-indigo-700 transition-colors"
        >
          ← Voltar para Home
        </button>
      </div>
    </div>
  );
}
